import { useEffect } from "react";

function useEffect1(callback: () => void, dependencies: unknown[]) {
  useEffect(callback, dependencies);
}

export default useEffect1;
